import { render, staticRenderFns } from "./edicaoForm.vue?vue&type=template&id=32d8e8a1"
import script from "./edicaoForm.vue?vue&type=script&lang=js"
export * from "./edicaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports